var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84998 20.15C12.1 20.1 13.9 18.55 14 16.15C14.2 17.15 14.65 18.05 15.15 18.8C13.8 19.85 12.5 20.3 11.2 20.3C10.7 20.3 10.3 20.25 9.84998 20.15Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.95 15.95C28.95 16.15 28.8 16.35 28.6 16.35H28.1V16C28.2 14.7 27.9 13.8 27.35 13L28.6 13.35C28.85 13.45 28.95 13.55 28.95 13.9V15.95Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.95C3 13.6 3.05 13.45 3.35 13.4L4.65 13C4.05 13.85 3.75 15 3.8 16V16.35H3.35C3.15 16.35 3 16.2 3 15.95V13.95Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54999 12.9C8.24999 12.05 9.19999 11.6 10.45 11.6C12.75 11.6 14.55 13 15.45 15.3L15.9 16.5C17.05 19.5 18.5 21 20.25 21.55C17.55 21.15 15.45 19.55 14.55 16.9L14.15 15.7C13.3 13.25 11.95 12.1 9.84999 12.1C8.99999 12.1 8.14999 12.4 7.54999 12.9Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 10.8C25.9 11.15 27.8 13.2 27.8 15.6C27.8 17.7 26.2 19.4501 24.05 19.6C25.5 18.7 26.05 17.5 26.05 15.9C26.05 13.55 24.95 11.5 23.2 10.8Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 10.65C17.65 11.05 16.8 11.7 16 12.55C14.95 11.5 14.3 11.1 13.1 10.7L18.7 10.65Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 12.8C17.6 11.3 19.4 10.5 20.95 10.5C22.9 10.5 24.8 11.75 25.45 14C24.55 12.5 23.05 12.05 22 12.05C19.85 12.05 17.95 13.85 17.95 16.1C17.45 14.45 16.75 13.3 16.2 12.8Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15002 16C4.15002 12.75 6.65002 10.5 10.3 10.5C13.65 10.5 16.25 12.3 17.4 15.4L17.75 16.35C18.7 18.95 20.25 20.15 22.5 20.15C24.2 20.15 26.15 19.6 27.15 18.4C26.3 20.35 24.4 21.45 22.1 21.45C19.45 21.45 17.55 19.7 16.4 16.7L15.9 15.35C14.8 12.75 12.95 11.25 10.5 11.25C7.75002 11.25 5.85002 13.2 5.85002 15.95C5.85002 18.75 7.90002 20.65 11 20.65C12 20.65 12.9 20.45 13.75 20.05C12.75 21 11.35 21.5 9.80002 21.5C6.55002 21.5 4.15002 19.15 4.15002 16Z",
    fill: "#000041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 11,
    fill: "white",
    transform: "translate(3 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkglass);
export default __webpack_public_path__ + "static/media/lkglass.a76187ca019ec02600b4cb87eb51f555.svg";
export { ForwardRef as ReactComponent };